import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Link } from 'react-router-dom'
import './ButtonLink.scss'

type ButtonLinkProps = {
  icon?: IconProp
  href?: React.ComponentProps<typeof Link>['to']
  text?: string
  children?: React.ReactNode
} & Omit<React.ComponentProps<typeof Link>, 'to' | 'children'>

class ButtonLink extends React.PureComponent<ButtonLinkProps> {
  static defaultProps = {
    icon: undefined as IconProp | undefined,
    href: '/' as React.ComponentProps<typeof Link>['to'],
    text: '',
  }

  render() {
    const { icon, href = '/', text, children, ...rest } = this.props
    return (
      <Link className="ButtonLink" to={href} {...rest}>
        {icon && <FontAwesomeIcon icon={icon} />}
        {text || children}
      </Link>
    )
  }
}

export default ButtonLink
